import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/delete-icon-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-648ad7b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal__content rmd:!tw-pb-4" }
const _hoisted_2 = { class: "left_upload_img" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Upload images and files.", -1))
const _hoisted_4 = { class: "upload__area" }
const _hoisted_5 = { class: "uploade-wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "error_msg"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload__text" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Drag and drop documents, or"),
    /*#__PURE__*/_createElementVNode("span", null, "Browse")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "" }, " Attachments such as images, design ideas and documents help better understand the project and provide increasingly accurate estimates. ")
], -1))
const _hoisted_8 = { class: "attachment-list !tw-p-4 sm:!tw-p-0" }
const _hoisted_9 = { class: "attachment-list__header" }
const _hoisted_10 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_11 = {
  key: 0,
  class: "tw-w-[20px] tw-h-[20px] tw-rounded-full tw-bg-[#1FB27A] tw-flex tw-flex-col tw-items-center tw-justify-center"
}
const _hoisted_12 = {
  key: 0,
  class: "attachment-list__list"
}
const _hoisted_13 = { class: "attachment-list__image rmd:!tw-w-full" }
const _hoisted_14 = { class: "attachment-list__image-init" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Image"
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "attachment-list__name" }
const _hoisted_21 = { class: "attachment-list__content rmd:!tw-w-full" }
const _hoisted_22 = {
  key: 1,
  class: "no-attachment"
}
const _hoisted_23 = { class: "footer-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_Text = _resolveComponent("Text")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_CommonLoader = _resolveComponent("CommonLoader")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    isShowHeader: false,
    isShowBackButton: false,
    width: "832px",
    "max-width": "100%",
    persistent: "",
    className: ['phaseproof__upload__modal ']
  }, {
    body: _withCtx(() => [
      _createVNode(_component_v_form, {
        ref: "attachFormRef",
        rules: $setup.validation,
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            icon: "mdi-close",
            class: "close__icon",
            disabled: $setup.isLoadingUploadAttachments,
            onClick: $setup.onClickToggleAttachmentModal
          }, null, 8, ["disabled", "onClick"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_v_file_input, {
                    class: _normalizeClass(["upload_file", { 'added-img': $setup.imageUrl }]),
                    label: "Upload",
                    modelValue: $setup.selectedFile,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedFile) = $event)),
                    clearable: $setup.imageUrl ? true : false,
                    "append-inner-icon": "mdi-image-plus",
                    variant: "solo-filled",
                    onChange: $setup.onFileChange,
                    "onClick:clear": $setup.clearImageUrl,
                    multiple: ""
                  }, null, 8, ["modelValue", "clearable", "class", "onChange", "onClick:clear"]),
                  _createVNode(_component_v_img, {
                    class: "uploaded-img",
                    width: 200,
                    "aspect-ratio": "16/9",
                    cover: "",
                    src: $setup.imageUrl
                  }, null, 8, ["src"]),
                  ($setup.errorMessage)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($setup.errorMessage), 1))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_7
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Text, {
                    variant: "h6",
                    textWeight: "600"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Uploaded Files")
                    ]),
                    _: 1
                  }),
                  ($setup.attachmentDataList?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_Text, {
                          variant: "xsmall",
                          textColor: "#fff",
                          textWeight: "400"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.attachmentDataList.length), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (!$setup.isLoading && $setup.attachmentDataList.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.attachmentDataList, (attachment, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "attachment-list__item rmd:!tw-flex rmd:!tw-flex-col rmd:!tw-w-full"
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            ($setup.isImageType(attachment?.uploadedImages))
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "attachment-list__image-covered",
                                  src: attachment?.uploadedImages?.url,
                                  alt: "Image"
                                }, null, 8, _hoisted_15))
                              : (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  class: "tw-h-[85px]",
                                  src: 
                        require('@/assets/icons/sidebar-icons/documents.svg')
                      ,
                                  alt: "icon"
                                }, null, 8, _hoisted_16)),
                            (!$setup.isLoadingUploadAttachments)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  onClick: ($event: any) => (
                        $setup.removeImageFromAttachments(
                          index,
                          attachment?.uploadedImages?.id
                        )
                      ),
                                  class: "attachment-list__delete"
                                }, _hoisted_19, 8, _hoisted_17))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("p", null, _toDisplayString(attachment?.uploadedImages?.name), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_v_select, {
                            modelValue: attachment.propertyId,
                            "onUpdate:modelValue": ($event: any) => ((attachment.propertyId) = $event),
                            label: "Select property",
                            items: $setup.projectProperties,
                            rules: $setup.validation.property,
                            "item-title": "address",
                            "item-value": "id",
                            multiple: "",
                            variant: "outlined",
                            density: "compact",
                            class: "selectprop_dropdown",
                            "menu-props": {
                      contentClass: 'members__selector__dropdown',
                    }
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"]),
                          _createVNode(_component_v_select, {
                            modelValue: attachment.taskId,
                            "onUpdate:modelValue": ($event: any) => ((attachment.taskId) = $event),
                            label: "Select Task",
                            items: $props.phaseDetails.projectStageTasks,
                            "item-title": "name",
                            "item-value": "id",
                            variant: "outlined",
                            density: "compact",
                            class: "selectprop_dropdown",
                            "menu-props": {
                      contentClass: 'members__selector__dropdown',
                    }
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, " Your added project attachments will show up here ")),
              ($setup.isLoading)
                ? (_openBlock(), _createBlock(_component_CommonLoader, {
                    key: 2,
                    loading: true,
                    class: "loader-container"
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_v_btn, {
              class: "button button-purple-border",
              onClick: $setup.onClickToggleAttachmentModal,
              variant: "outlined",
              disabled: $setup.isLoadingUploadAttachments
            }, {
              default: _withCtx(() => [
                _createTextVNode(" cancel ")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_v_btn, {
              class: "button button-orange",
              loading: $setup.isLoadingUploadAttachments,
              disabled: $setup.isLoading,
              onClick: $setup.onClickSaveButtonAttachmentsModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(" save ")
              ]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"])
          ])
        ]),
        _: 1
      }, 8, ["rules"])
    ]),
    _: 1
  }))
}